// extracted by mini-css-extract-plugin
export var learn = "style-module--learn--fffcb";
export var learn__container = "style-module--learn__container--68725";
export var learn__description = "style-module--learn__description--0ee54";
export var learn__info = "style-module--learn__info--4ae71";
export var learn__move = "style-module--learn__move--3c73f";
export var learn__title = "style-module--learn__title--e4f03";